"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonWaitingRoomDTO = void 0;
class PersonWaitingRoomDTO {
    constructor() {
        this.micOn = true;
        this.name = "null";
        this.sessionPeerId = "undefined";
    }
}
exports.PersonWaitingRoomDTO = PersonWaitingRoomDTO;
